import { ICONS } from "../icons.map";

export enum SEVERITY {
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
}

export const SensitivityLevelHelper = {
  from_str: (str: string) => {
    switch (str) {
      case "High":
      case "high":
      case "h":
        return 3;
      case "Medium":
      case "medium":
      case "m":
        return 2;
      case "Low":
      case "low":
      case "l":
        return 1;
      case "None":
      case "none":
      default:
      case "n":
        return 0;
    }
  },
  as_dropdown: (levels: number[]) => {
    const levels_str = [
      "None sensitivity",
      "Low sensitivity",
      "Medium sensitivity",
      "High sensitivity",
    ];
    return levels.map((value) => {
      return {
        id: value.toString(),
        value,
        name: levels_str[value],
        icon: ICONS.SENSITIVITIES.get(value),
      };
    });
  },
  floatToInt: (num: number) => {
    if (!num) {
      return 0;
    }
    if (num >= 1) {
      return num;
    }
    switch (true) {
      case num === 0:
        return 0;
      case num > 0 && num < 0.3:
        return 1;
      case num >= 0.3 && num < 0.7:
        return 2;
      default:
        return 3;
    }
  },
  intToFloat: (num: number) => {
    if (!num) {
      return 0;
    }
    switch (num) {
      case 0:
        return 0;
      case 1:
        return 0.2;
      case 2:
        return 0.5;
      case 3:
      default:
        return 0.85;
    }
  },
  intToString: (num: number) => {
    if (!num) {
      return "None";
    }
    switch (num) {
      case 0:
        return "None";
      case 1:
        return "Low";
      case 2:
        return "Medium";
      case 3:
      default:
        return "High";
    }
  },
};
